// src/data/locations.js
// This file centralizes all location and viewpoint data for the virtual tour.

// LOCATIONS object: Defines the structure of the apartment, including rooms (locations)
// and specific viewpoints within each room.
// Each location has an ID, name, a list of viewpoints, and minimap positions/color.
// Each viewpoint has an ID, name, description, image path, rotation offsets,
// minimap positions, and a list of interactive hotspots.
export const LOCATIONS = {
  living: {
    id: 'living',
    name: 'Living Room',
    viewpoints: [
      {
        id: 'living_entrance',
        name: 'Entrance View',
        description: 'View from the entrance of the living room.',
        image: 'assets/images/Entrance_VRay.jpg',
        rotationOffset: 0, // Rotation in degrees for panorama alignment
        directionOffset: 90, // Direction offset for minimap pointer
        minimap3DPosition: [-2, 0, -6], // 3D coordinates for minimap marker
        minimap2DPosition: { x: 50, y: 80 }, // 2D coordinates for minimap marker (relative to floorplan)
        hotspots: [
          // {
          //   id: 'to_kitchen',
          //   target: 'kitchen',
          //   targetViewpoint: 'kitchenDoor',
          //   label: 'Kitchen',
          //   panoramaPosition: [-4, -3, -2], // 3D position of hotspot in panorama
          //   minimap3DPosition: [2.5, 0, -6], // 3D position of hotspot on minimap
          //   minimap2DPosition: { x: 80, y: 40 } // 2D position of hotspot on minimap
          // },
          {
            id: 'to_living_door',
            target: 'living',
            targetViewpoint: 'living_door',
            label: 'Living Door',
            panoramaPosition: [-4, -3, -2],
            minimap3DPosition: [-4, 0, 4],
            minimap2DPosition: { x: 20, y: 80 }
          },
          {
            id: 'to_living_sofa',
            target: 'living',
            targetViewpoint: 'living_sofa',
            // transitionVideo: "assets/videos/newHD.mp4",  // Add this,
            label: 'Sofa View',
            panoramaPosition: [5, -3, 2],
            minimap3DPosition: [0, 0, -6],
            minimap2DPosition: { x: 50, y: 30 }
          }
        ]
      },
      {
        id: 'living_sofa',
        name: 'Sofa View',
        description: 'View from the sofa area in the living room.',
        image: 'assets/images/sofa_new.jpg',
        rotationOffset: 0,
        directionOffset: 90,
        minimap3DPosition: [-4.5, 0, -7.5],
        minimap2DPosition: { x: 20, y: 50 },
        hotspots: [
          // {
          //   id: 'to_bedroom',
          //   target: 'bedroom',
          //   targetViewpoint: 'bedroom_main',
          //   label: 'Bedroom',
          //   panoramaPosition: [0, -3, -8],
          //   minimap3DPosition: [0, 0, -6],
          //   minimap2DPosition: { x: 50, y: 20 }
          // },
          {
            id: 'to_living_entrance',
            target: 'living',
            targetViewpoint: 'living_entrance',
            // transitionVideo: "assets/videos/newHD_Rev.mp4",  // Add this,
            label: 'Entrance View',
            panoramaPosition: [-5.2, -2, -2],
            minimap3DPosition: [0, 0, -6],
            minimap2DPosition: { x: 50, y: 30 }
          }
        ]
      },
      {
        id: 'living_door',
        name: 'Door View',
        description: 'View from the Door area in the living room.',
        image: 'assets/images/living_door.jpg',
        rotationOffset: 0,
        directionOffset: 90,
        minimap3DPosition: [0, 0, -4.6],
        minimap2DPosition: { x: 20, y: 50 },
        hotspots: [
          {
            id: 'to_corridor',
            target: 'living',
            targetViewpoint: 'living_corridor',
            // transitionVideo: "assets/videos/newHD_Rev.mp4", 
            label: 'Corridor View',
            panoramaPosition: [0, -2, -3.5],
            minimap3DPosition: [0, 0, -6],
            minimap2DPosition: { x: 50, y: 30 }
          },
          {
            id: 'to_living_main',
            target: 'living',
            targetViewpoint: 'living_main',
            // transitionVideo: "assets/videos/newHD_Rev.mp4", 
            label: 'Living Main View',
            panoramaPosition: [3, -2, 1.3],
            minimap3DPosition: [0, 0, -6],
            minimap2DPosition: { x: 50, y: 30 }
          }
        ]
      },
      {
        id: 'living_corridor',
        name: 'Corridor View',
        description: 'View from the Corridor area in the living room.',
        image: 'assets/images/Corrior.jpg',
        rotationOffset: 0,
        directionOffset: 90,
        minimap3DPosition: [0, 0, -2.1],
        minimap2DPosition: { x: 20, y: 50 },
        hotspots: [
          {
            id: 'to_living_door',
            target: 'living',
            targetViewpoint: 'living_door',
            // transitionVideo: "assets/videos/newHD_Rev.mp4", 
            label: 'Living Door View',
            panoramaPosition: [0, -2, 4],
            minimap3DPosition: [0, 0, -6],
            minimap2DPosition: { x: 50, y: 30 }
          },
           {
            id: 'to_kitchenDoor',
            target: 'kitchen',
            targetViewpoint: 'kitchenDoor',
            label: 'Door View',
            panoramaPosition: [4, -3, 0],
            minimap3DPosition: [0, 0, -6],
            minimap2DPosition: { x: 50, y: 20 }
          }
        ]
      }
    ],
    minimap3DPosition: { x: -4, z: -6 }, // Main position for location label in 3D minimap
    minimap2DPosition: { x: 150, y: 150 }, // Main position for location label in 2D minimap
    // color: '#4F46E5' // Color associated with this location (for minimap markers)
  },
  kitchen: {
    id: 'kitchen',
    name: 'Kitchen',
    viewpoints: [
      {
        id: 'kitchenDoor',
        name: 'Door View',
        description: 'View from the kitchen door.',
        image: 'assets/images/Kitchen_Entrance_2.jpg',
        rotationOffset: 0,
        directionOffset: 90,
        minimap3DPosition: [-1.8, 0, -2],
        minimap2DPosition: { x: 250, y: 80 },
        hotspots: [
          {
            id: 'to_corridor',
            target: 'living',
            targetViewpoint: 'living_corridor',
            // transitionVideo: "assets/videos/newHD_Rev.mp4", 
            label: 'Corridor View',
            panoramaPosition: [-5, -3, 0],
            minimap3DPosition: [0, 0, -6],
            minimap2DPosition: { x: 50, y: 30 }
          },
          {
            id: 'to_kitchen_main',
            target: 'kitchen',
            targetViewpoint: 'kitchen_main',
            label: 'Main Kitchen',
            panoramaPosition: [4.5, -3, 1.5],
            minimap3DPosition: [0, 0, 6],
            minimap2DPosition: { x: 50, y: 80 }
          },
          {
            id: 'to_bedroom_entrance',
            target: 'bedroom',
            targetViewpoint: 'bedroom_entrance',
            label: 'Bedroom Entrance',
            panoramaPosition: [0, -3, -3],
            minimap3DPosition: [0, 0, -6],
            minimap2DPosition: { x: 50, y: 20 }
          }
        ]
      },
      {
        id: 'kitchen_main',
        name: 'Main View',
        description: 'Main kitchen view.',
        image: 'assets/images/kitchen_main.jpg',
        rotationOffset: 0,
        directionOffset: 90,
        minimap3DPosition: [-5, 0, -2.5],
        minimap2DPosition: { x: 250, y: 100 },
        hotspots: [
          // {
          //   id: 'to_living',
          //   target: 'living',
          //   targetViewpoint: 'living_entrance', // Changed to entrance for consistency
          //   label: 'Living Room',
          //   panoramaPosition: [-5, -3, -1.6],
          //   minimap3DPosition: [-6, 0, 2.5],
          //   minimap2DPosition: { x: 15, y: 65 }
          // },
          {
            id: 'to_kitchenDoor',
            target: 'kitchen',
            targetViewpoint: 'kitchenDoor',
            label: 'Door View',
            panoramaPosition: [-6, -3, -1.6],
            minimap3DPosition: [0, 0, -6],
            minimap2DPosition: { x: 50, y: 20 }
          }
        ]
      },
    ],
    minimap3DPosition: { x: -4, z: -3 },
    minimap2DPosition: { x: 250, y: 100 },
    // color: '#DC2626'
  },
  bedroom: {
    id: 'bedroom',
    name: 'Bedroom',
    viewpoints: [
      {
        id: 'bedroom_entrance',
        name: 'Bedroom Entrance',
        description: 'View from the entrance of the bedroom.',
        image: 'assets/images/Bedroom_Entrance_1.jpg',
        rotationOffset: 0,
        directionOffset: 90,
        minimap3DPosition: [-1.2, 0, -0.5],
        minimap2DPosition: { x: 50, y: 220 },
        hotspots: [
          {
            id: 'to_bedroom_main',
            target: 'bedroom',
            targetViewpoint: 'bedroom_main',
            label: 'Main View',
            panoramaPosition: [6, -3, 0],
            minimap3DPosition: [0, 0, 6],
            minimap2DPosition: { x: 50, y: 80 }
          },
          {
            id: 'to_bathroom',
            target: 'bathroom',
            targetViewpoint: 'bathroom_main',
            label: 'Bathroom',
            panoramaPosition: [0, -3, -3.5],
            minimap3DPosition: [-6, 0, 0],
            minimap2DPosition: { x: 20, y: 50 }
          },
          {
            id: 'to_kitchenDoor',
            target: 'kitchen',
            targetViewpoint: 'kitchenDoor',
            label: 'Door View',
            panoramaPosition: [0, -3, 3],
            minimap3DPosition: [0, 0, -6],
            minimap2DPosition: { x: 50, y: 20 }
          }
        ]
      },
      {
        id: 'bedroom_main',
        name: 'Main View',
        description: 'Main bedroom view.',
        image: 'assets/images/Bedroom_Main.jpg',
        rotationOffset: 0,
        directionOffset: 90,
        minimap3DPosition: [-4, 0, 0],
        minimap2DPosition: { x: 50, y: 250 },
        hotspots: [
          {
            id: 'to_living',
            target: 'living',
            targetViewpoint: 'living_sofa',
            label: 'Living Room',
            panoramaPosition: [8, 0, 2],
            minimap3DPosition: [6, 0, 1.5],
            minimap2DPosition: { x: 80, y: 60 }
          },
          {
            id: 'to_bathroom',
            target: 'bathroom',
            targetViewpoint: 'bathroom_main',
            label: 'Bathroom',
            panoramaPosition: [-3, 0, -8],
            minimap3DPosition: [-2.5, 0, -6],
            minimap2DPosition: { x: 35, y: 20 }
          },
          {
            id: 'to_bedroom_entrance',
            target: 'bedroom',
            targetViewpoint: 'bedroom_entrance',
            label: 'Bed View',
            panoramaPosition: [-4, -3, 0],
            minimap3DPosition: [0, 0, -6],
            minimap2DPosition: { x: 50, y: 20 }
          }
        ]
      },
    ],
    minimap3DPosition: { x: -5, z: 1 },
    minimap2DPosition: { x: 50, y: 250 },
    // color: '#059669'
  },
  bathroom: {
    id: 'bathroom',
    name: 'Bathroom',
    viewpoints: [
      {
        id: 'bathroom_main',
        name: 'Main View',
        description: 'Main bathroom view.',
        image: 'assets/images/Bathroom_1.jpg',
        rotationOffset: 0,
        directionOffset: 90,
        minimap3DPosition: [-1.5, 0, 1.5],
        minimap2DPosition: { x: 20, y: 180 },
        hotspots: [
          {
            id: 'to_bedroom_entrance',
            target: 'bedroom',
            targetViewpoint: 'bedroom_entrance',
            label: 'Bed View',
            panoramaPosition: [0, -3, 4],
            minimap3DPosition: [0, 0, -6],
            minimap2DPosition: { x: 50, y: 20 }
          }
        ]
      }
    ],
    minimap3DPosition: { x: -1, z: 1.5 },
    minimap2DPosition: { x: 20, y: 180 },
    // color: '#7C3AED'
  },
};

// Helper function to determine if a hotspot is for internal navigation within the same room.
export const isHotspotInternal = (hotspot, currentViewpointId) => {
  const currentRoomId = currentViewpointId.split('_')[0];
  return hotspot.target === currentRoomId;
};
